import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel, {
  FormControlLabelProps,
} from '@mui/material/FormControlLabel'
import { useField } from 'formik'
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox'
import { FormHelperText } from '@mui/material'

type FormikCheckboxProps = CheckboxProps & {
  name: string
  formControlLabelProps: FormControlLabelProps & {
    control: React.ReactElement<any, any> | null
  }
}

const FormikCheckbox: React.FC<FormikCheckboxProps> = ({
  formControlLabelProps,
  ...props
}) => {
  const [{ ...field }, { error, touched }] = useField(props.name)
  return (
    <>
      <FormControlLabel
        {...formControlLabelProps}
        control={
          formControlLabelProps.control || (
            <Checkbox
              {...field}
              name={props.name}
              checked={!!field.value}
              color='secondary'
              {...props}
            />
          )
        }
      />
      {touched && error && (
        <FormHelperText className='px-14' error={true}>
          {error}
        </FormHelperText>
      )}
    </>
  )
}

export default FormikCheckbox
